import { Injectable } from "@angular/core";
import { lastValueFrom, Observable } from "rxjs";
import { DataResult, ICRUD } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_DISCOUNT_GROUP_CUSTOMER_GROUP_RELATION, GET_DISCOUNT_GROUP_CUSTOMER_GROUP_RELATION, GET_DISCOUNT_GROUP_CUSTOMER_GROUP_RELATIONS, SAVE_DISCOUNT_GROUP_CUSTOMER_GROUP_RELATION } from "../../../data/definitions/discount-group-customer-group-relation.definition";
import { QueryResult } from "../../../data/query-result";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DeleteDiscountGroupCustomerGroupRelationMutation, DeleteDiscountGroupCustomerGroupRelationMutationVariables, DeletionResponse, DiscountGroupCustomerGroupRelation, DiscountGroupCustomerGroupRelationInput, DiscountGroupCustomerGroupRelationSearchInput, GetDiscountGroupCustomerGroupRelationQuery, GetDiscountGroupCustomerGroupRelationQueryVariables, GetDiscountGroupCustomerGroupRelationsQuery, GetDiscountGroupCustomerGroupRelationsQueryVariables, SaveDiscountGroupCustomerGroupRelationMutation, SaveDiscountGroupCustomerGroupRelationMutationVariables } from "../../../generated/generated-types";

@Injectable({
    providedIn: 'root'
})
export class DiscountGroupCustomerGroupRelationService extends BaseListService<DiscountGroupCustomerGroupRelation> implements ICRUD<DiscountGroupCustomerGroupRelation> {
    constructor(
        private baseDataService: BaseDataService,
        private systemService: SystemService,
    ) {
        super();
    }

    getData(searchInput?: DiscountGroupCustomerGroupRelationSearchInput/*, options?: ICRUDOptions*/): Observable<DataResult<DiscountGroupCustomerGroupRelation>> {
        return super.getData(searchInput);
    }

    getItems(searchInput: DiscountGroupCustomerGroupRelationSearchInput): QueryResult<GetDiscountGroupCustomerGroupRelationsQuery> {
        let fragment = GET_DISCOUNT_GROUP_CUSTOMER_GROUP_RELATIONS;

        return this.baseDataService.query<GetDiscountGroupCustomerGroupRelationsQuery, GetDiscountGroupCustomerGroupRelationsQueryVariables>(
            fragment, {
            input: searchInput
        });
    }

    getItem(id: string): QueryResult<GetDiscountGroupCustomerGroupRelationQuery> {
        return this.baseDataService.query<GetDiscountGroupCustomerGroupRelationQuery, GetDiscountGroupCustomerGroupRelationQueryVariables>(
            GET_DISCOUNT_GROUP_CUSTOMER_GROUP_RELATION, {
            id: id
        });
    }

    async getItemData(id: string): Promise<DiscountGroupCustomerGroupRelation> {
        return (await lastValueFrom(await this.getItem(id).mapSingle(x => x.getDiscountGroupCustomerGroupRelation as DiscountGroupCustomerGroupRelation)));
    }

    getItemStream(id: string): Observable<DiscountGroupCustomerGroupRelation> {
        return this.getItem(id).mapStream(x => x.getDiscountGroupCustomerGroupRelation as DiscountGroupCustomerGroupRelation);
    }

    async saveItem(item: DiscountGroupCustomerGroupRelationInput): Promise<DiscountGroupCustomerGroupRelation> {
        // if (!item.type)
        //     item.type = DiscountGroupType.CUSTOMERGROUP;

        let validated = await this.systemService.validateObject<DiscountGroupCustomerGroupRelationInput>(item, "DiscountGroupCustomerGroupRelationInput");

        let saved = await lastValueFrom(await this.baseDataService.mutate<SaveDiscountGroupCustomerGroupRelationMutation, SaveDiscountGroupCustomerGroupRelationMutationVariables>(
            SAVE_DISCOUNT_GROUP_CUSTOMER_GROUP_RELATION, {
            input: validated
        }));
        return saved.saveDiscountGroupCustomerGroupRelation as DiscountGroupCustomerGroupRelation;
    }

    async deleteItem(id: string): Promise<DeletionResponse> {
        let res = await lastValueFrom(await this.baseDataService.mutate<DeleteDiscountGroupCustomerGroupRelationMutation, DeleteDiscountGroupCustomerGroupRelationMutationVariables>(
            DELETE_DISCOUNT_GROUP_CUSTOMER_GROUP_RELATION, {
            id: id
        }));

        return res.deleteDiscountGroupCustomerGroupRelation;
    }
}